module.exports = __webpack_public_path__ + "img/1_002.93554cb8.webp";